import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=80cfad84&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80cfad84')) {
      api.createRecord('80cfad84', component.options)
    } else {
      api.reload('80cfad84', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=80cfad84&", function () {
      api.rerender('80cfad84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P4lnR0dAT7V1/JS/pricehelp.vue"
export default component.exports